<template>
  <tr class="d-table-tr" :class="{'d-table-tr--odd': index % 2 === 1 }">
    <td @click="toggleSubject(subject)">
      <div class="d-checkbox" :class="{'d-checkbox--active': isSelected}"></div>
    </td>
    <td>{{ subject.subject.name }}</td>
    <td>
      <template v-if="subject.calendar">
        {{ subject.calendar.name }}
      </template>
    </td>
    <td>
      <template v-if="subject.subject.calendar">
        {{ subject.subject.calendar.name }}
      </template>
    </td>
    <td>{{ subject.v_type }}</td>
    <td v-if="!isSupplements">{{ subject.v_DefaultCategory && subject.v_DefaultCategory.name }}</td>
    <td :content="'Tildel til flere i stedet'"
        v-tippy="{
            placement: 'left',
                arrow: false,
                animateFill: false,
                animation : 'shift-away',
                zIndex: '999999992',
                boundary: 'window',
                onShow: () => selectedSubjects.length > 0
            }">
      <select class="do-select"
              :class="{'do-select--disabled': selectedSubjects.length > 0}"
              v-if="!isSupplements && taskCategories.length > 0"
              v-model="subject.selected_task_category_id"
              @change="updateSubjectTaskCategory(subject, $event.target.value)">
        <option v-for="(taskCategory, key) in taskCategories"
                :key="taskCategory.id"
                :value="taskCategory.id">
          {{ taskCategory.name }}
        </option>
      </select>
      <select class="do-select width-100"
              :class="{'do-select--disabled': selectedSubjects.length > 0}"
              v-if="isSupplements && supplementTypes.length > 0"
              v-model="subject.salary_supplement_type_id"
              @change="updateSubjectTaskCategory(subject, $event.target.value)">
        <option value=""></option>
        <option v-for="(supplementType, key) in supplementTypes"
                :key="supplementType.id"
                :value="supplementType.id">
          {{ supplementType.title }} ({{ supplementType.code }})
        </option>
      </select>
    </td>
  </tr>
</template>
<script>
export default {
  props: {
    source: { // here is: {uid: 'unique_1', text: 'abc'}
      type: Object,
      default () {
        return {}
      }
    },
    toggleSubject: {
      type: Function
    },
    updateSubjectTaskCategory: {
      type: Function
    },
    selectedSubjects: {
      default () {
        return () => []
      }
    },
    taskCategories: {
      default () {
        return () => []
      }
    },
    selectedSubjectIds: {
      default () {
        return () => {}
      }
    },
    index: { // index of current item
      type: Number
    },
    isSupplements: {
      type: Boolean,
      default: false
    },
    supplementTypes: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    subject () {
      return this.source
    },
    isSelected () {
      return this.selectedSubjectIds.has(this.subject.id)
    }
  }
}
</script>

<style scoped>
.d-table-tr td {
  padding: 0.5rem 0.5rem;
  cursor: pointer;
  border-left: 1px solid #e2e8f0;
}
.d-table-tr td:first-child:hover .d-checkbox {
  box-shadow: 0 0 1px 2px #468ad791;
}
.d-table-tr td:first-child {
  width: 58px;
}

.d-table-tr--odd {
  background-color: #f9fafb;
}

.do-select--disabled {
  opacity: 0.6;
  pointer-events: none;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// TaskOverviewSettingsCategoriesTasksTask.vue?580ff5ac